import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";

import { CloseFollowUp } from "./";
import { SelectInput } from "../../../../common/form";
import * as dataActions from "../../../../../utils/data/dataActions";

import { USERS, FOLLOW_UP_CATEGORIES } from "../../../../../utils/data/models";

class MultiFollowUpFields extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {
    this.props.dataActions.getDataList(
      FOLLOW_UP_CATEGORIES,
      0,
      0,
      "",
      ["followUpCategoryOrder:asc"],
      [FOLLOW_UP_CATEGORIES.categorizeFilter]
    );

    this.props.dataActions.getDataList(
      USERS,
      0,
      0,
      "",
      ["firstName:asc", "lastName:asc"],
      [
        USERS.archiveFilter,
        USERS.planManagerFilter,
        USERS.informationAgentFilter,
      ]
    );
  }

  render() {
    const { showSelectedCheckboxes, closeFollowUp, handleSubmit, userList } = this.props;
    const users = userList.map((user) => {
      return { value: user.userId, text: `${user.firstName} ${user.lastName}` };
    });
    const categories = this.props.followUpCategoryList
      .sort((a, b) => a.followUpCategoryOrder - b.followUpCategoryOrder)
      .map((category) => {
        return {
          value: category.followUpCategoryId,
          text: category.localizations[this.props.languageCode].name,
        };
      });
    let mapping = {};
    mapping.showSelectedCheckboxes = showSelectedCheckboxes;

    return (
      <div>
        <span className="icon icon-warning" />
        <FormattedMessage
          id ="common.modifySelectionElement"
          values={mapping}>
          {(m) => (
            <span className="formatted-confimation"
            dangerouslySetInnerHTML={{__html: m}}/>
          )}
        </FormattedMessage>
        <form className="pad_top" 
          onSubmit={handleSubmit}>
          <div className="sub-group">
            <Field
              id="recipientUserId"
              name="recipientUserId"
              component={SelectInput}
              addBlankOption={true}
              options={users}
              label={
                <FormattedMessage id="members.followUps.form.followUpRecipient" />
              }
              searchable={true}
            />
            <Field
              id="followUpCategoryId"
              name="followUpCategoryId"
              component={SelectInput}
              addBlankOption={true}
              options={categories}
              label={<FormattedMessage id="members.followUps.form.category" />}
              searchable={true}
            />
            <CloseFollowUp closeFollowUp={closeFollowUp} />
          </div>
        </form>
      </div>
    );
  }
}

MultiFollowUpFields.propTypes = {
  closeFollowUp: PropTypes.bool,
  dataActions: PropTypes.object,
  handleSubmit: PropTypes.func,
  userList: PropTypes.array,
  showSelectedCheckboxes: PropTypes.number,
  followUpCategoryList: PropTypes.array,
  languageCode: PropTypes.string,
};

function mapStateToProps(state) {
  const selector = formValueSelector("editMultipleFollowUps");
  const userData = state.data.users || {};
  const followUpCategoryData = state.data.followUpCategories || {};
  const languageCodeData = state.auth.user.languageCode || "en-CA";
  return {
    showSelectedCheckboxes: state.followUpActions.count,
    closeFollowUp: selector(state, "closeFollowUp"),
    userList: userData.items || [],
    followUpCategoryList: followUpCategoryData.items || [],
    languageCode: languageCodeData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "editMultipleFollowUps",
  })(MultiFollowUpFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/MultiFollowUpFields.js